import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'he', label: 'עברית' },
];

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`px-2.5 py-1 text-sm font-medium rounded-md transition-colors ${
            i18n.language === lang.code || i18n.language.startsWith(lang.code)
              ? 'bg-gold-100 text-gold-700 ring-1 ring-gold-300'
              : 'text-gray-600 hover:text-gold-600 hover:bg-gold-50'
          }`}
          aria-label={`Switch to ${lang.label}`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
